module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"onfield_claim.claim_parts":"อะไหล่ที่ทำการยื่นเคลม","onfield_claim.claim_parts.description":"สามารถเคลมได้เฉพาะอะไหล่ที่มีเลข SKU ในระบบนี้เท่านั้น (ถ้ารายการไหนไม่มีรบกวนติดต่อทาง HGR เพื่อนำข้อมูลเข้าระบบ)"}}')
  delete Component.options._Ctor
}
